export const OPCD_API_STATUS = {
  PENDING: "Pending",
  COMPLETED: "Completed",
} as const;

export const OPCD_MODULE_SLUG = {
  OUTPATIENT_CDI: "/m/outpatient-cdi",
  OUTPATIENT_PRO_FEE: "/m/outpatient/pro-fee",
} as const;

export const OPCD_RESPONSE_STATUS = {
  COMPLETED: "completed",
} as const;

export const OPCD_STATUS_FILTER_OPTIONS = [
  { value: OPCD_API_STATUS.PENDING, label: "Open" },
];

export const EASTERN_TIME_ZONE = "America/New_York";
